import { render, staticRenderFns } from "./MasterdataTableContainer.vue?vue&type=template&id=275ae47e"
import script from "./MasterdataTableContainer.vue?vue&type=script&lang=js"
export * from "./MasterdataTableContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports